import { useState } from "react";
import ParticleApi from "../Api/ParticleApi";
import { CircularProgress, Typography, Grid, Button } from "@mui/material";

function ParticleShortFunction(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [error, setError] = useState(null);

  const handleSendCommandSet = async () => {
    setIsLoading(true);
    for (const i in props.calls) {
      const command = props.calls[i];

      await ParticleApi.callFunction(
        props.coreId,
        command.func,
        command.args.join(" "),
        props.productId
      )
        .then((resp) => {
          console.log("Call: " + command.func + " Response: " + resp.response);
          setResult([
            ...result,
            "Call: " + command.func + " Response: " + resp.response,
          ]);
          setError(null);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setError(error.message);
          setIsLoading(false);
        });
    }
  };

  return (
    <Grid item xs={12} md={12} lg={12}>
      <Grid container spacing={1} alignItems={"center"}>
        <Grid item xs={12} md={12} lg={6}>
          <div className="buttonWrapper">
            <Button
              onClick={handleSendCommandSet}
              color="primary"
              variant="contained"
              disabled={isLoading || props.coreId === ""}
            >
              {props.name}
            </Button>
            {isLoading && (
              <CircularProgress size={24} className="buttonProgress" />
            )}
          </div>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <Typography variant="body1" className="typeMargins">
            {result.join(" ")}
            {error}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ParticleShortFunction;
